import React from 'react';
import classNames from 'classnames';
import { Autoplay, Pagination } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import { SectionTilesTypesProps } from '../../../utils/SectionProps';
import SectionHeader, { SectionHeaderTag } from '../partials/SectionHeader';
import { Service } from '../../../types/service';
import { AllJsonData } from '../../../types/graphql';
import ServiceCard from './partials/ServiceCard';
import Button from '../../elements/Button';

interface ServicesProps extends SectionTilesTypesProps, AllJsonData<Service, { services: [] }> {
  className?: string;
  services: Service[];
  title: string;
  subtitle?: string;
  description?: string;
  bottomDescription: string;
  isInnerSection?: boolean;
  isSlider?: boolean;
}

const defaultProps: Partial<ServicesProps> = {
  services: [],
  topOuterDivider: false,
  bottomOuterDivider: false,
  topDivider: false,
  bottomDivider: false,
  hasBgColor: false,
  invertColor: false,
  pushLeft: false,
  isInnerSection: false,
  isSlider: false,
};

const Services: React.FC<ServicesProps> = ({
  className,
  topOuterDivider,
  bottomOuterDivider,
  topDivider,
  bottomDivider,
  hasBgColor,
  invertColor,
  pushLeft,
  services,
  title,
  subtitle,
  description,
  bottomDescription,
  isInnerSection,
  isSlider,
  ...props
}) => {
  const outerClasses = classNames(
    'services section',
    topOuterDivider && 'has-top-divider',
    bottomOuterDivider && 'has-bottom-divider',
  );

  const innerClasses = classNames(
    'features-tiles-inner section-inner',
    topDivider && 'has-top-divider',
    bottomDivider && 'has-bottom-divider',
  );

  const tilesClasses = classNames(
    'tiles-wrap',
    isSlider && 'tiles-spaceless tiles-full-width',
    pushLeft && 'push-left',
  );

  const swiperOptions: Swiper = {
    modules: [Pagination, Autoplay],
    pagination: { clickable: true, el: '.swiper-pagination' },
    slidesPerView: 1,
    spaceBetween: 24,
    breakpoints: {
      576: {
        slidesPerView: 2,
      },
      992: {
        slidesPerView: 3,
      },
    },
    autoplay: {
      delay: 10000,
      disableOnInteraction: false,
    },
  };

  return (
    <section id="services-section" {...props} className={outerClasses}>
      <div className="container">
        <div className={innerClasses}>
          <SectionHeader
            tag={isInnerSection ? SectionHeaderTag.H2 : SectionHeaderTag.H1}
            title={title}
            className="center-content"
          >
            {subtitle && <h2 className="h4">{subtitle}</h2>}
            {description && <p className="mb-0">{description}</p>}
          </SectionHeader>
          <div className={tilesClasses}>
            {isSlider ? (
              <Swiper {...swiperOptions} className="swiper-container pb-32">
                <div className="swiper-wrapper">
                  {services?.map((service, i) => (
                    <SwiperSlide key={i} className="swiper-slide">
                      <ServiceCard service={service} key={i} className="h-100 p-0" />
                    </SwiperSlide>
                  ))}
                </div>
                <div className="swiper-pagination swiper-pagination-clickable swiper-pagination-bullets swiper-pagination-horizontal mb-n16" />
              </Swiper>
            ) : (
              services?.map((service, i) => <ServiceCard service={service} key={i} className="reveal-from-bottom" />)
            )}
          </div>
          <div className="center-content">
            <div className="spacer-64 spacer-32-mobile" />
            <div className="container-xs reveal-from-bottom">
              <p className="text-white">{bottomDescription}</p>
              <Button
                tag="a"
                color="primary"
                wideMobile
                target="_blank"
                href="https://calendly.com/teambit-atlassian/demo"
              >
                Contact us
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

Services.defaultProps = defaultProps;

export default Services;
